import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-14 w-[90%] mx-auto"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-6 text-4xl font-bold text-center text-primary-500 lg:text-5xl" }, [
  /*#__PURE__*/_createTextVNode(" Welcome to "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Shinagawa Patient Portal ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-6 text-2xl font-bold text-center text-black-500 lg:text-2xl" }, [
  /*#__PURE__*/_createTextVNode(" We are currently conducting maintenance to our system. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sorry for the inconvenience."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" We will be back soon. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" For any inquiries regarding your booking, please contact us using the information found below. ")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "py-14 w-[90%] mx-auto"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-6 text-4xl font-bold text-center text-primary-500 lg:text-5xl" }, [
  /*#__PURE__*/_createTextVNode(" Welcome to "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Shinagawa Patient Portal ")
], -1)
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-right mb-7" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/forgot-password",
    class: "m-0 text-xs text-darkgray-400"
  }, "Forgot Password?")
], -1)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-400" }, [
    /*#__PURE__*/_createTextVNode("Dont have an account yet? "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/signup",
      class: "font-bold text-primary-500"
    }, "Sign up now")
  ])
], -1)

import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
// import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';

import { ref, onMounted } from 'vue';
import Storage from '@/helpers/storage';
import AuthService from "@/classes/AuthService";
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const route = ref<any>(null);

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref()
const errors = ref([])
const maintenanceMode = ref<boolean>(false)
const token = ref<string>('')

const form = ref({
    email: '',
    password: '',
})

const login = () => {
    loader.value = true;

    AuthService.login(form.value.email, form.value.password)
    .then((result: any) => {
        loader.value = false;

        if(result.data.access_token) {
            const tokens = new Storage();
            const accessToken = `${result.data.token_type} ${result.data.access_token}`;
            const hybrainToken = result.data.hybrain;

            tokens.set('access_token', accessToken)
            tokens.set('hybrain_token', hybrainToken)
            tokens.set('patient', JSON.stringify(result.data.patient))

            console.log(result.data);

            window.location.replace('/overview');
        }
    }).catch( (err: any) => {
        loader.value = false;
        showError.value = true;
        errorMsg.value = err.response.data.message;

        if(err.response.status == 422) {
            errors.value = err.response.data.errors;
        }
    })
}

onMounted(() => {
    route.value = useRoute();
    if (route.value?.query?.token) {
        token.value = String(route.value.query.token);
    }

    maintenanceMode.value = AuthService.checkMode(token.value);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      (maintenanceMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("form", {
              class: "w-full md:w-[450px] mx-auto",
              onSubmit: _withModifiers(login, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(TextInput, {
                  type: "email",
                  placeholder: "Email",
                  modelValue: form.value.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
                  error: errors.value.email ? errors.value.email[0] : ''
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(PasswordInput, {
                  id: "password",
                  modelValue: form.value.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
                  placeholder: "Password"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(ButtonComponent, {
                  disabled: loader.value,
                  text: "Login",
                  type: 'submit'
                }, null, 8, ["disabled"])
              ])
            ], 40, _hoisted_7),
            _hoisted_12
          ])),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"])
    ]),
    _: 1
  }))
}
}

})